import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import SegmentsIndex from 'components/SegmentsIndex';
import SegmentsEdit from 'components/SegmentsEdit';
import SegmentsView from 'components/SegmentsView';

import { ACCOUNT_PERMISSIONS } from 'constants/accountManagement/permissions';
import { selectUserRole } from 'reducers/account/users';
import { selectUserId } from 'reducers/user';

const BASE_PATH = '/segments';

const Segments = ({ match: { path = BASE_PATH } = {} }) => {
  const userId = useSelector(selectUserId);
  const role = useSelector(state => selectUserRole(state, userId));
  const canEditSegments = role !== ACCOUNT_PERMISSIONS.EDITOR;

  return (
    <Switch>
      <Route path={`${path}/:segmentId/view`} component={SegmentsView} />
      {canEditSegments && (
        <Route path={`${path}/:segmentId/edit`} component={SegmentsEdit} />
      )}
      <Route path={path} component={SegmentsIndex} />
    </Switch>
  );
};

Segments.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

export default Segments;
